import clone from 'ramda/es/clone'

export default class UserInputResult
{
    constructor(pace='standard')
    {
        this.userInputs = []
        this.pace = pace
    }

    setPace(pace='standard')
    {
        this.pace = pace
    }

    isPace(value)
    {
        return this.pace === value
    }

    prefixUserInput(expectedBlue, expectedRed, userInputForBlue, userInputForRed)
    {
        this.userInputs.unshift(clone({
            expectedInput: {
                blue: expectedBlue,
                red: expectedRed
            },
            userInput: {
                blue: userInputForBlue,
                red: userInputForRed
            }
        }))
    }

    getResultStructure()
    {
        return {
            context: {
                pace: this.pace,
            },
            userInputs: this.userInputs
        }
    }

    resetResultStructureWith(data)
    {
        this.pace = data ? data.context.pace || 'standard' : 'standard';

        this.userInputs = data ? data.userInputs || [] : [];
    }

    correctUserInputCount()
    {
        const isCorrect = (given, expected) => given.blue===expected.blue && given.red===expected.red

        return this.userInputs.filter( ui => isCorrect(ui.userInput, ui.expectedInput) ).length
    }

    userInputCount()
    {
        return this.userInputs.length
    }
}